<script lang="ts" setup>
import { useAgentBeautician } from '~/composable/agent';
import CEAbout from './aboutUs.vue'
import { OutletModel } from '~/models/outlet'
import { dataFetchSingleWhere } from '~/realm/data/get'
import { imageSrcset } from '~/shared/im';

const $acl = useAclStore()
const $router = useRouter()

const { isOutletOwner, isOutlet, isAgent }  = useAgentBeautician()
const isAgentOrOutlet = computed(() => isOutlet.value)
const outletModel = new OutletModel()

const outlet = ref<OutletType>()
watchEffect(async () => {
  if (isOutlet.value) {
    const cond = isOutletOwner.value ? { managerId: $acl.currentUser.uid }: { _id: $acl.currentUser.customData.outletId }
    return dataFetchSingleWhere(outletModel, cond).then((res) => {
      console.log('outlet', {res, cond})
      outlet.value = res
    })
  }
}, { immediate: true })

</script>
<template>
  <div>
    <CEAbout v-if="!isAgentOrOutlet" />
    <div v-else class="flex flex-col">
      <ClientOnly>
        <img :srcset="imageSrcset(outlet?.bannerPhotoURL)" class="w-full my-2" />
        <div class="my-2 " v-html="outlet?.aboutUS">

        </div>
      </ClientOnly>
    </div>
  </div>
</template>